import React from 'react';
import styled from 'styled-components';
import { read_quest_provider_counts } from '../../utils/quest/quest_provider_counts';

const QuestProviderCounts = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: nowrap;
`;

const QuestProviderCount = styled.div`
    --quest-provider-color: var(--facebook);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.8rem;
    padding: 0.35rem 0.6rem;
    border: 0.1rem solid color-mix(in srgb, var(--quest-provider-color) 36%, transparent);
    border-radius: var(--smallRadius);
    color: var(--quest-provider-color);
    background: color-mix(in srgb, var(--quest-provider-color) 12%, transparent);

    &[data-provider="google"] {
        --quest-provider-color: var(--google);
    }

    &[data-status="inactive"] {
        opacity: 0.45;
    }

    h6 {
        color: inherit;
        white-space: nowrap;
    }
`;

// Keeps all four provider/status values in a fixed, compact order.
export const Quest_Provider_Counts = ({ brand, t = value => value }) => {
    const counts = read_quest_provider_counts(brand);
    const activeLabel = t('Active quests');
    const inactiveLabel = t('Inactive quests');
    const metaLabel = t('Meta');
    const googleLabel = t('Google');
    const metaActive = counts.byProvider.meta.active;
    const metaInactive = counts.byProvider.meta.inactive;
    const googleActive = counts.byProvider.google.active;
    const googleInactive = counts.byProvider.google.inactive;

    return (
        <QuestProviderCounts data-testid="quest-provider-counts">
            <QuestProviderCount
                title={`${activeLabel}, ${metaLabel}: ${metaActive}`}
                aria-label={`${activeLabel}, ${metaLabel}: ${metaActive}`}
                data-provider="meta"
                data-status="active"
            >
                <h6>{metaActive}</h6>
            </QuestProviderCount>
            <QuestProviderCount
                title={`${inactiveLabel}, ${metaLabel}: ${metaInactive}`}
                aria-label={`${inactiveLabel}, ${metaLabel}: ${metaInactive}`}
                data-provider="meta"
                data-status="inactive"
            >
                <h6>{metaInactive}</h6>
            </QuestProviderCount>
            <QuestProviderCount
                title={`${activeLabel}, ${googleLabel}: ${googleActive}`}
                aria-label={`${activeLabel}, ${googleLabel}: ${googleActive}`}
                data-provider="google"
                data-status="active"
            >
                <h6>{googleActive}</h6>
            </QuestProviderCount>
            <QuestProviderCount
                title={`${inactiveLabel}, ${googleLabel}: ${googleInactive}`}
                aria-label={`${inactiveLabel}, ${googleLabel}: ${googleInactive}`}
                data-provider="google"
                data-status="inactive"
            >
                <h6>{googleInactive}</h6>
            </QuestProviderCount>
        </QuestProviderCounts>
    );
};
